import type { ReactNode } from 'react';
import { db } from '../../api/core';
import { assetFileUrl, assetThumb, coverThumb } from '../../components/thumb';
import { Markup } from '../../components/Markup';
import { Glyph } from './ui';
import './media-preview.css';

export function entityCover(entity: any): any | null {
  const cover = entity?.cover || entity?.data?.cover || entity?.app_config?.cover;
  return /^[0-9a-f-]{36}$/i.test(cover?.asset_id || '') ? { ...entity, cover } : null;
}

export function executionPreviewAsset(run: any): any | null {
  const stored = db.assets.find(asset => asset.execution_id === run?.id || asset.run_id === run?.id);
  const outputs = [run?.previews, run?.node_outputs, run?.outputs, run?.generation_outputs].flatMap(value => Array.isArray(value) ? value : value && typeof value === 'object' ? Object.values(value) : []);
  for (const output of outputs as any[]) {
    if (!output || typeof output !== 'object') continue;
    const id = output.asset_id || output.storage_object_id || output.id;
    const asset = db.assets.find(item => item.id === id);
    if (asset) return asset;
    if (/^[0-9a-f-]{36}$/i.test(id || '') || /^https?:\/\//i.test(output.url || '')) return {
      ...output, name:output.name || 'Execution output', storage_object_id:id,
      type:String(output.type || output.kind || 'IMAGE').toUpperCase(), external_url:output.url,
    };
    if (typeof output.text === 'string') return { name:'Text output', origin:'output-node', definition:{ text:output.text } };
  }
  return stored || null;
}

export function MediaPreview({ asset }: { asset: any }) {
  if (!assetFileUrl(asset) && !(asset?.origin === 'output-node' && typeof asset?.definition?.text === 'string')) {
    const type = String(asset?.type || 'FILE').toUpperCase();
    const kind = type === 'VIDEO' ? 'video' : type === 'AUDIO' ? 'audio' : ['TEXT', 'PROMPT'].includes(type) ? 'text' : ['IMAGE', 'REFERENCE'].includes(type) ? 'image' : 'any';
    return <span className="v2-media-preview v2-media-empty"><Glyph family="type" name={kind} size={24} /><small>{type.replaceAll('_', ' ')}</small></span>;
  }
  return <span className="v2-media-preview"><Markup value={assetThumb(asset, 'thumb v2-media-thumb')} /></span>;
}

export function EntityPreview({ entity, fallback }: { entity: any; fallback?: ReactNode }) {
  const covered = entityCover(entity);
  return covered ? <span className="v2-media-preview"><Markup value={coverThumb(covered, 'thumb v2-media-thumb')} /></span> : <>{fallback ?? <Glyph name="flows" size={24} />}</>;
}

export function ExecutionPreview({ run, fallback }: { run: any; fallback?: ReactNode }) {
  const asset = executionPreviewAsset(run);
  return asset ? <MediaPreview asset={asset} /> : <>{fallback}</>;
}
